
        <div [formGroup]="form">
            <!-- Product Category & Product (FR-FR only) -->
            <div class="row" *ngIf="lang === 'fr-fr'">
              <app-product-category-fields [form]="form" [lang]="lang"></app-product-category-fields>
            </div>

            <!-- Row 1: Question -->
            <div class="row">
              <div class="col-md-12">
                <div class="form-group mb-3">
                  <label for="question" class="form-label">{{ labels.question }} <span class="ast">*</span></label>
                  <textarea
                    id="question"
                    class="form-control"
                    formControlName="question"
                    [class.is-invalid]="isFieldInvalid('question')"
                    rows="4"
                    placeholder="{{ placeholders.enterYourQuestion }}" maxlength="2000"></textarea>
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('question')">
                    <span *ngIf="form.get('question')?.hasError('required')">
                       {{ messages.fieldRequired }}
                    </span>
                    <span *ngIf="form.get('question')?.hasError('minlength')">
                   {{ messages.characterLimit }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
        </div>
